import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Image, Spinner } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { setWishListDataCount } from '../../../reducers/wishlistSlice'
import { fetch } from '../../../utils'
import { addToCart } from '../../../reducers/cart'
import { Link, useNavigate } from 'react-router-dom'
import CartSidebar from '../../component/CartSidebar'

const Wishlist = () => {
  const [loading, setLoading] = useState(true)
  const [wishListData, setWishListData] = useState([])
  const [isCartSidebarOpen, setIsCartSidebarOpen] = useState(false)
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const getWishListData = async () => {
    try {
      const token = localStorage.getItem('muskan_token')
      if (!token) return navigate('/account/login')

      const response = await fetch('/wishlist/all', 'post', null, {
        Authorization: `Bearer ${token}`,
      })

      const wishlist = response?.data?.data?.wishlist || response?.data?.data || []
      const data = Array.isArray(wishlist) ? wishlist : []

      setWishListData(data)
      dispatch(setWishListDataCount(data))
    } catch (error) {
      console.log('Wishlist error:', error)
      setWishListData([])
      dispatch(setWishListDataCount([]))
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getWishListData()
  }, [])

  const getAttributeValues = product => {
    let values = product?.attribute_values || []

    if (typeof values === 'string') {
      try {
        values = JSON.parse(values)
      } catch {
        values = []
      }
    }

    if (!Array.isArray(values)) values = []

    if (!values.length && product?.attribute_id && product?.attribute_value_id) {
      values = [{
        attribute_value_id: Number(product.attribute_value_id),
        attribute_id: Number(product.attribute_id),
        attribute_value: product?.attribute_value || null,
      }]
    }

    return values
  }

  const handleRemoveWishList = async (product_id, product = null) => {
    try {
      const token = localStorage.getItem('muskan_token')
      if (!token) return navigate('/account/login')

      const attribute_values = getAttributeValues(product || {})

      const response = await fetch(
        '/wishlist/remove',
        'post',
        {
          product_id: Number(product_id),
          attribute_values,
        },
        {
          Authorization: `Bearer ${token}`,
        }
      )

      if (!response?.data?.success) {
        console.log('Remove wishlist failed:', response?.data?.message)
        return false
      }

      const data = wishListData.filter(item => {
        if (Number(item.product_id) !== Number(product_id)) return true
        if (!product) return false

        return JSON.stringify(getAttributeValues(item)) !== JSON.stringify(attribute_values)
      })

      setWishListData(data)
      dispatch(setWishListDataCount(data))
      return true
    } catch (error) {
      console.log('Remove wishlist error:', error)
      return false
    }
  }

  const handleAddToCart = product => {
    const selectedAttribute = product?.selected_attribute || {}

    const productMRP = Number(
      product?.selected_product_MRP ??
      product?.product_MRP ??
      0
    )

    const productMSP = Number(
      product?.selected_product_MSP ??
      product?.product_MSP ??
      0
    )

    const attributeValueId =
      product?.selected_attribute_value_id ??
      selectedAttribute?.attribute_value_id ??
      product?.attribute_value_id ??
      null

    const attributeValue =
      selectedAttribute?.attribute_value ??
      product?.attribute_value ??
      product?.size ??
      null

    const cartItem = {
      product_id: Number(product.product_id),
      product_name: product.product_name,
      product_slug: product.product_slug,
      product_thumbnail: product.product_thumbnail,
      brand_id: product.brand_id,
      category_id: product.category_id,
      sub_category_id: product.sub_category_id,
      gst_id: product.gst_id,
      gst_percent: product.gst_percent,
      product_code: product.product_code,
      product_sku: product.product_sku,
      product_description: product.product_description,
      product_additional_information: product.product_additional_information,
      in_stock_status: product.in_stock_status,
      attributes: product.attributes,
      attribute_value_id: attributeValueId ? Number(attributeValueId) : null,
      size: attributeValue,
      product_MRP: productMRP,
      product_MSP: productMSP,
      quantity: 1,
      subTotal: productMSP,
    }

    dispatch(addToCart(cartItem))
    setIsCartSidebarOpen(true)
  }

  if (loading) {
    return (
      <Container className="text-center my-5" style={{ height: '500px' }}>
        <Spinner animation="border" role="status">
          <span className="sr-only">Loading.....</span>
        </Spinner>
      </Container>
    )
  }

  if (!wishListData.length) {
    return (
      <Container>
        <Row className="pt-2">
          <Col>
            <font>Home › Wishlist</font>

            <div className="pt-4">
              <h3 style={{ fontWeight: '500' }}>Wishlist</h3>
            </div>

            <div className="text-center my-5">
              <Image
                src={require('../../assets/images/empty-cart.jpg')}
                alt="image"
              />
              <p>No products added to the wishlist</p>

              <Link to="/" className="btn btn-primary">
                Shop Now
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    )
  }

  return (
    <div className="py-5">
      <Container>
        <font>Home › Wishlist</font>

        <div className="mt-3 pb-3 text-center">
          <h3>My Wishlist</h3>
        </div>

        <div className="mt-2 px-lg-5 px-sm-0">
          <table className="table">
            <thead className="thead-light">
              <tr>
                <th>#</th>
                <th style={{ width: '8%' }}></th>
                <th>Product Name</th>
                <th>Selected Variant</th>
                <th>Unit Price</th>
                <th>Stock Status</th>
                <th></th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {wishListData.map((item, index) => {
                const selectedAttribute = item?.selected_attribute || {}

                const productMRP = Number(
                  item?.selected_product_MRP ??
                  item?.product_MRP ??
                  0
                )

                const productMSP = Number(
                  item?.selected_product_MSP ??
                  item?.product_MSP ??
                  0
                )

                return (
                  <tr key={item.wishlist_id || `${item.product_id}-${index}`}>
                    <th>{index + 1}</th>

                    <td>
                      <img
                        src={item.product_thumbnail}
                        alt={item.product_name}
                        className="w-100"
                      />
                    </td>

                    <td>
                      <Link
                        to={`/product/${item.product_slug}`}
                        className="text-decoration-none"
                      >
                        {item.product_name}
                      </Link>
                    </td>

                    <td>
                      {selectedAttribute?.attribute_name && (
                        <div>
                          <strong>
                            {selectedAttribute.attribute_name}:
                          </strong>{' '}
                          {selectedAttribute.attribute_value}
                        </div>
                      )}

                      {!selectedAttribute?.attribute_name &&
                        item?.attribute_value && (
                          <div>
                            <strong>Size:</strong> {item.attribute_value}
                          </div>
                        )}
                    </td>

                    <td className="main-color">
                      <i className="fa fa-inr"></i> {productMSP}

                      {productMRP > productMSP && (
                        <del
                          className="text-muted ms-2"
                          style={{ fontSize: '13px' }}
                        >
                          <i className="fa fa-inr"></i> {productMRP}
                        </del>
                      )}
                    </td>

                    <td className="text-success">
                      {item.in_stock_status === 'In Stock' ? (
                        <>
                          <i
                            className="fa fa-check me-1"
                            aria-hidden="true"
                          />
                          {item.in_stock_status}
                        </>
                      ) : (
                        <span className="text-danger">
                          {item.in_stock_status}
                        </span>
                      )}
                    </td>

                    <td>
                      <button
                        className="btn btn-sm btn-danger rounded-1 main-bg"
                        style={{
                          padding: '0 5px',
                          lineHeight: '20px',
                        }}
                        onClick={() => handleAddToCart(item)}
                        disabled={item.in_stock_status !== 'In Stock'}
                      >
                        + Add to Cart
                      </button>
                    </td>

                    <td>
                      <button
                        className="btn"
                        onClick={() =>
                          handleRemoveWishList(item.product_id, item)
                        }
                      >
                        <i
                          className="fa fa-times"
                          aria-hidden="true"
                        />
                      </button>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </Container>

      <CartSidebar
        isOpen={isCartSidebarOpen}
        closeSidebar={() => setIsCartSidebarOpen(false)}
      />
    </div>
  )
}

export default Wishlist